import { get } from '../helpers/axiosHelper'

const url = `https://windon.encyon.se/api/rss.php`

const fetch = async () => get(`${url}`)

export default {
  fetch
}
